import { Navigate, Outlet } from 'react-router-dom';
import { getAuthToken } from '../api/api';

export default function PrivateRoute() {
  const token = getAuthToken();
  if (!token) return <Navigate to="/login" replace />;
  return <Outlet />;
}
